var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4904 1.95652H13.2415L12.1357 0.290218C12.0764 0.200993 11.9962 0.127829 11.9021 0.0772056C11.808 0.0265828 11.7029 6.44062e-05 11.5962 0H6.40385C6.2971 6.44062e-05 6.19202 0.0265828 6.09791 0.0772056C6.00381 0.127829 5.92358 0.200993 5.86433 0.290218L4.75772 1.95652H2.50962C1.99321 1.95652 1.49795 2.16265 1.1328 2.52957C0.767642 2.89649 0.5625 3.39414 0.5625 3.91304V13.0435C0.5625 13.5624 0.767642 14.06 1.1328 14.4269C1.49795 14.7939 1.99321 15 2.50962 15H15.4904C16.0068 15 16.502 14.7939 16.8672 14.4269C17.2324 14.06 17.4375 13.5624 17.4375 13.0435V3.91304C17.4375 3.39414 17.2324 2.89649 16.8672 2.52957C16.502 2.16265 16.0068 1.95652 15.4904 1.95652ZM11.9207 8.15217C11.9207 8.73262 11.7494 9.30003 11.4285 9.78265C11.1075 10.2653 10.6514 10.6414 10.1177 10.8636C9.58401 11.0857 8.99676 11.1438 8.4302 11.0306C7.86365 10.9173 7.34324 10.6378 6.93477 10.2274C6.52631 9.81694 6.24814 9.29401 6.13545 8.72472C6.02275 8.15543 6.08059 7.56534 6.30165 7.02908C6.52271 6.49282 6.89706 6.03447 7.37736 5.71199C7.85766 5.38951 8.42235 5.21739 9 5.21739C9.77461 5.21739 10.5175 5.52659 11.0652 6.07697C11.613 6.62735 11.9207 7.37382 11.9207 8.15217Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.370930c66c02600a3990584132137b16.svg";
export { ForwardRef as ReactComponent };